import { IApplicationState } from '../../../../../../types/types';
import { getAsidePanel } from './getAsidePanel';
import { ASIDE_MAX_WIDTH, EViewTypes } from '../../../../../../const';
import { getPanelReadonly } from '../../../boardDetails/selectors/getPanelReadonly';
import { getActiveBoardId } from '../../../../../../store/model/selectors/getActiveBoardId';
import { getTypeSwitcherActiveType } from '../../../../typeSwitcher/store/selectors/getTypeSwitcherActiveType';
import { isBoardSettings } from '../../../../../../store/router/selectors/isBoardSettings';

export const getAsidePanelEntityPanelWidth = (
    state: IApplicationState
): number => {
    const activeBoard = getActiveBoardId(state);
    const isReadOnly = getPanelReadonly(state, activeBoard);
    const viewType = getTypeSwitcherActiveType(state, activeBoard);
    const isBoardSetting = isBoardSettings(state);
    let width;
    if ((isReadOnly && !isBoardSetting && activeBoard) || (!isReadOnly && viewType === EViewTypes.ARCHIVE_VIEW_TYPE)) {
        width = ASIDE_MAX_WIDTH;
    } else {
        width = getAsidePanel(state).entityPanelWidth;
    }
    return width;
};
